<template>
    <div
        :class="contentWidth === 'boxed' && layout !== 'full' ? 'container p-0' : null"
        class="h-100"
    >
        <router-view />
    </div>
</template>

<script>
import useAppConfig from '@core/app-config/useAppConfig'
import { getCurrentInstance } from '@vue/composition-api'
export default {
    setup () {
        const { contentWidth } = useAppConfig()
        const vm = getCurrentInstance().proxy
        const layout = vm.$route.meta.layout
        return {
            contentWidth,
            layout
        }
    }
}
</script>
